// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6de6fd4","239":"07023809","455":"ea479caf"}[chunkId] + ".chunk.js";
};